import axios from 'axios';
import { vendorUrlRegexPath, withPimURL } from 'src/helpers/service';

export interface IAcceptFlashDiscountBody {
  acceptedFlashDiscountId: number;
  acceptedPrice: number;
}

export const acceptFlashDiscountMutationKey = () => {
  return ['accept-flash-discount'];
};

export const acceptFlashDiscount = async (body: IAcceptFlashDiscountBody) => {
  return axios.post<any>(withPimURL(vendorUrlRegexPath('/flash-discount/:vendorId/accept')), body).then((res) => res.data);
};
